import actions from './actions';

const {
  GET_BITAQATY_BALANCE_BEGIN,
  GET_BITAQATY_BALANCE_SUCCESS,
  GET_BITAQATY_BALANCE_ERR,
  GET_BITAQATY_MERCHANTS_BEGIN,
  GET_BITAQATY_MERCHANTS_SUCCESS,
  GET_BITAQATY_MERCHANTS_ERR,
  GET_BITAQATY_PRODUCTS_BEGIN,
  GET_BITAQATY_PRODUCTS_SUCCESS,
  GET_BITAQATY_PRODUCTS_ERR,
} = actions;

const initState = {
  loadingGetBitaqatyBalance: false,
  errorGetBitaqatyBalance: null,
  balance: 0,

  loadingGetBitaqatyMerchants: false,
  errorGetBitaqatyMerchants: null,
  merchants: [],

  loadingGetBitaqatyProducts: false,
  errorGetBitaqatyProducts: null,
  products: [],
};

/**
 *
 * @todo impure state mutation/explaination
 */
const bitaqatyReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_BITAQATY_MERCHANTS_BEGIN:
      return {
        ...state,
        loadingGetBitaqatyMerchants: true,
        errorGetBitaqatyMerchants: null,
      };
    case GET_BITAQATY_MERCHANTS_SUCCESS:
      return {
        ...state,
        merchants: data,
        loadingGetBitaqatyMerchants: false,
        errorGetBitaqatyMerchants: null,
      };
    case GET_BITAQATY_MERCHANTS_ERR:
      return {
        ...state,
        loadingGetBitaqatyMerchants: false,
        errorGetBitaqatyMerchants: err,
      };

    case GET_BITAQATY_BALANCE_BEGIN:
      console.log('get balance begin');
      return {
        ...state,
        loadingGetBitaqatyBalance: true,
        errorGetBitaqatyBalance: null,
      };
    case GET_BITAQATY_BALANCE_SUCCESS:
      console.log('get balance success', data);

      return {
        ...state,
        balance: data,
        loadingGetBitaqatyBalance: false,
        errorGetBitaqatyBalance: null,
      };
    case GET_BITAQATY_BALANCE_ERR:
      console.log('get balance err', err);
      return {
        ...state,
        loadingGetBitaqatyBalance: false,
        errorGetBitaqatyBalance: err,
      };

    case GET_BITAQATY_PRODUCTS_BEGIN:
      return {
        ...state,
        loadingGetBitaqatyProducts: true,
        errorGetBitaqatyProducts: null,
      };
    case GET_BITAQATY_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: data,
        loadingGetBitaqatyProducts: false,
        errorGetBitaqatyProducts: null,
      };
    case GET_BITAQATY_PRODUCTS_ERR:
      return {
        ...state,
        loadingGetBitaqatyProducts: false,
        errorGetBitaqatyProducts: err,
      };
    default:
      return state;
  }
};
export { bitaqatyReducer };
